
import {Component, Vue} from "vue-property-decorator";
import {alertModule, usersModule} from "@/store";

@Component
export default class UserPasswordRecoveryView extends Vue {
    emailAddress: string = "";
    sendSuccessful: boolean = false;
    loading: boolean = false;

    rules: any = {
        required: (v: string) => !!v || 'Wird benötigt',
        email: (v: string) => this.isValidEmailAddress(v) || 'Ungültige Emailaddresse'
    };

    isValidEmailAddress(value: string): boolean {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return !!value && pattern.test(value);
    }

    async sendMail() {
        this.loading = true;
        console.log("send mail to " + this.emailAddress);
        try {
            await usersModule.sendPasswordRecoveryMail(this.emailAddress);
            this.sendSuccessful = true;
        } catch (e) {
            await alertModule.error("Allgemeiner Fehler");
        }
        this.loading = false;
    }
}
